var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M7 0.000244141C3.13438 0.000244141 0 3.13462 0 7.00024C0 10.8659 3.13438 14.0002 7 14.0002C10.8656 14.0002 14 10.8659 14 7.00024C14 3.13462 10.8656 0.000244141 7 0.000244141ZM6.5 3.62524C6.5 3.55649 6.55625 3.50024 6.625 3.50024H7.375C7.44375 3.50024 7.5 3.55649 7.5 3.62524V7.87524C7.5 7.94399 7.44375 8.00024 7.375 8.00024H6.625C6.55625 8.00024 6.5 7.94399 6.5 7.87524V3.62524ZM7 10.5002C6.80374 10.4962 6.61687 10.4155 6.47948 10.2752C6.3421 10.135 6.26515 9.94655 6.26515 9.75024C6.26515 9.55394 6.3421 9.36546 6.47948 9.22524C6.61687 9.08503 6.80374 9.00425 7 9.00024C7.19626 9.00425 7.38313 9.08503 7.52052 9.22524C7.6579 9.36546 7.73485 9.55394 7.73485 9.75024C7.73485 9.94655 7.6579 10.135 7.52052 10.2752C7.38313 10.4155 7.19626 10.4962 7 10.5002Z",
    fill: "#FAAD14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnion);
export default __webpack_public_path__ + "static/media/icon-union.39f45a0f0adcd25591c1f1248c51fff7.svg";
export { ForwardRef as ReactComponent };